import React from "react";
import { useSdkContext } from "scmp-sdk/components/contexts";

import type { MessageRender } from "./hooks";
import { useDashboardMessages } from "./hooks";
import { ReadingHistoryPanel } from "./reading-history-panel";
import { useReadingHistoryWithArticle } from "./reading-history-panel/hooks";
import {
  Container,
  Content,
  Footer,
  Greeting,
  Header,
  HeaderContent,
  Link,
  Message,
  UserName,
} from "./styles";

export type Props = {
  beforeHeaderSlot?: React.ReactNode;
  className?: string;
  messageRenders: Array<MessageRender>;
};

export const DashboardDisplay: React.FunctionComponent<Props> = ({
  beforeHeaderSlot,
  className,
  messageRenders,
}) => {
  const { config, handleOpenLoginDialog, handleRoutePush, user } = useSdkContext();

  const username =
    user?.firstname && user?.lastname
      ? `${user.firstname} ${user.lastname}`
      : (user?.username ?? "Guest");

  const renderAccountLink = () => {
    if (!user) {
      return (
        <Link
          onClick={() => {
            handleOpenLoginDialog({
              destination: globalThis.location.href,
              ga4CustomParameter: {
                trigger_point: "header",
              },
            });
          }}
        >
          Sign In / Register
        </Link>
      );
    }

    return (
      <Link
        onClick={() => {
          const url = new URL(`${config.accounts.host}/settings`);
          url.searchParams.set("destination", globalThis.location.href);
          void handleRoutePush(url.toString());
        }}
      >
        My Account
      </Link>
    );
  };

  const { message } = useDashboardMessages(messageRenders);

  const { state: readingHistoryState } = useReadingHistoryWithArticle();

  return (
    <Container className={className}>
      <Header>
        {beforeHeaderSlot}
        <HeaderContent>
          <Greeting>
            Hi, <UserName>{username}</UserName>
          </Greeting>
          {renderAccountLink()}
          <Message>{message}</Message>
        </HeaderContent>
      </Header>
      <Content>
        <ReadingHistoryPanel state={readingHistoryState} />
      </Content>
      <Footer>{renderAccountLink()}</Footer>
    </Container>
  );
};

DashboardDisplay.displayName = "DashboardDisplay";
